export default __webpack_public_path__ + "static/donell-mcgary-5e53a2d88ad97ff8e25a8f2bf41783c6.png";